<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>

    <b-modal v-model="modal" :title="banderaFlujo != 8 ? 'Arribo' : 'Arribo en clínica'" centered size="lg">
      <div>
        <p style="font-weight: 600">¿En qué estado se entregó el paquete?</p>
      </div>
      <b-row class="mt-3">
        <b-col class="text-left">
          <p>Estado del paquete</p>
          <v-select
              :options="lista"
              label="descripcion"
              :reduce="(variable) => variable.id"
              v-model="$v.form.idEstado.$model"
              :class="selectClass('idEstado')"
          >
          </v-select>
        </b-col>
      </b-row>
      <b-row class="mt-4" v-if="form.idEstado === -1">
        <b-col class="text-left">
          <p>Comentarios</p>
          <b-form-group id="input-group-2" label-for="input-2">
            <b-form-input
                id="input-2"
                placeholder="Especifique"
                v-model="$v.form.comentario.$model"
                :state="validateState('comentario')"
                required
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <div slot="modal-footer">
        <b-button
          style="margin-right: 40px"
          variant="outline-primary"
          :disabled="loaderAcciones"
          @click="enviar()"
        >
          <span v-if="!loaderAcciones">Aceptar</span>
          <span v-if="loaderAcciones">
            <b-spinner small></b-spinner>
            Cargando...
          </span>
        </b-button>
        <b-button
          variant="outline-danger"
          :disabled="loaderAcciones"
          @click="modal = false"
          >Cancelar</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import {LaboratorioService} from "../../apiServices/laboratorio/LaboratorioService";
import {required} from "vuelidate/lib/validators";
import {CatalogosService} from "@/apiServices/catalogos/CatalogosService";
export default {
  name: "Arribo",
  components: {},
  props: {
    parametros: null,
    banderaFlujo: null,
  },
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      modal: true,
      laboratorioServicio: new LaboratorioService(),
      catalogoServicio: new CatalogosService(),
      idSolicitud: null,
      idEtapa: null,
      form: {
        idEstado: null,
        comentario: null
      },
      lista:[
      ]
    }
  },
  validations() {
    if (this.form.idEstado == -1) {
      return {form : {
        idEstado: {required},
        comentario: {required}
      }}
    }else {
      return {form : {
        idEstado: {required},
        comentario: {}
      }}
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.idSolicitud = this.parametros[0].idSolicitud
    this.idEtapa= this.parametros[0].idEtapa
    this.obetnerLlegadas();
  },
  methods:{
    obetnerLlegadas(){
      this.catalogoServicio.obtenerEstatusLlegadaPaquete()
          .then(response => {
            this.lista = response.data
            this.lista.push( {id: -1, descripcion: 'Otro'},)
          })
    },
    enviar() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return false;
      }
      this.laboratorioServicio.enviarIngreso(this.idSolicitud,this.idEtapa, this.form).then(
          () => {
            this.$swal({
              icon: "success",
              title: "Se registro correctamente",
              showConfirmButton: false
            });
            // this.$v.$reset()
            location.reload();
          })
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    selectClass(attribute) {
      let state = this.validateState(attribute)
      if ( state ) {
        return 'border rounded-lg border-success'
      } else if ( state === false) {
        return 'border rounded-lg border-danger'
      } else {
        return ''
      }
    },
  }
}
</script>

<style scoped>

</style>
